import { useFormContext } from "react-hook-form";

import { CheckboxField, ImageTile, TextInputField } from "@/components/kit";
import { BrandFormData } from "@/schemas/brand-form.schema";

interface BrandFormProps {
  disabledFields?: Array<keyof BrandFormData>;
}

/** The brand fields, read from the surrounding `FormProvider`. */
export const BrandForm = ({ disabledFields }: BrandFormProps) => {
  const { watch } = useFormContext<BrandFormData>();
  const image = watch("image");
  const disabled = (name: keyof BrandFormData) =>
    disabledFields?.includes(name);

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-4">
        <TextInputField<BrandFormData>
          isDisabled={disabled("name")}
          label="Brand name"
          isRequired
          name="name"
          placeholder="Enter brand name"
        />
        <TextInputField<BrandFormData>
          dir="rtl"
          isDisabled={disabled("nameAr")}
          label="Brand name (Arabic)"
          isRequired
          name="nameAr"
          placeholder="Brand name in Arabic"
        />
      </div>
      <TextInputField<BrandFormData>
        isDisabled={disabled("image")}
        label="Image URL"
        isRequired
        name="image"
        placeholder="Enter brand image URL"
        type="url"
      />
      {image ? (
        <div className="flex items-center gap-3">
          <ImageTile alt="Brand preview" size="sm" src={image} />
          <span className="text-muted text-sm">Brand image preview</span>
        </div>
      ) : null}
      <TextInputField<BrandFormData>
        description="Leave empty to auto-generate from brand name"
        isDisabled={disabled("id")}
        isMono
        label="Brand ID (optional)"
        name="id"
        placeholder="e.g., brand-slug"
      />
      <div className="flex gap-7">
        <CheckboxField<BrandFormData>
          isDisabled={disabled("isActive")}
          label="Active"
          name="isActive"
        />
        <CheckboxField<BrandFormData>
          isDisabled={disabled("isLocal")}
          label="Local brand"
          name="isLocal"
        />
      </div>
    </div>
  );
};
